import queryString from 'query-string'
import { isEmpty, isNil, pickBy } from 'ramda'

const getQueryParams = (query) => {
  const {
    broker_group: brokerGroup, utm_campaign: utmCampaign, dept_code: deptCode, fund_id: fundId, ref_id: refId
  } = queryString.parse(query)
  const isNotEmpty = (val) => !isNil(val) && !isEmpty(val)
  return pickBy(isNotEmpty, { brokerGroup, utmCampaign, deptCode, fundId, refId })
}

/* from DD.MM.YYYY to YYYY-MM-DD */
/**
 * @param {string} date
 * @returns {string}
 */
const convertToServerDate = (date) => {
  const dateAr = date.split('.')
  return `${dateAr[2]}-${dateAr[1]}-${dateAr[0]}`
}

/* from YYYY-MM-DD to DD.MM.YYYY */
/**
 * @param {string} date
 * @returns {string}
 */
const convertToClientDate = (date) => {
  if (date.indexOf('-') === -1) return date
  const dateAr = date.split('-')
  return `${dateAr[2]}.${dateAr[1]}.${dateAr[0]}`
}

const getQuestionnaireData = (extFields, externalFldValues, curTier) => {
  const qExtFields = extFields
    .filter(({ type, tier }) => tier === curTier && type === 'questionnaireSelect')
    .map(({ name }) => name)
  const isInList = (val, key) => qExtFields.indexOf(key) !== -1
  return pickBy(isInList, externalFldValues)
}

/**
 * Get a normalized string for special symbols.
 *
 * @param {string} symbols
 * @returns {string}
 */
const getSpecialsSymbolNormalizedString = (symbols) =>
  symbols.replaceAll(/[-.*+?!^=<>${}()|[\]\\/]/g, '\\$&')

/**
 * Get regular expression for special symbols
 *
 * @param {string} symbols
 * @param {string} [flag]
 * @returns {RegExp}
 */
const getSpecialsSymbolsRegExp = (symbols, flag) => {
  const specialsSymbols = getSpecialsSymbolNormalizedString(symbols)
  return new RegExp(`[${specialsSymbols}]`, flag)
}

const pammRefReg = /\d+PAMM\w+/

/**
 * @param {string | null | undefined} ref
 */
const isPammRef = (ref) => ref != null && pammRefReg.test(ref)

export {
  getQueryParams,
  convertToServerDate,
  convertToClientDate,
  getQuestionnaireData,
  getSpecialsSymbolNormalizedString,
  getSpecialsSymbolsRegExp,
  isPammRef
}
